// Helpers for the marketing email template served by the communication-templates API.
// The template HTML itself lives in the backend (identifier MARKETING_TRIGGER_AND_CAMPAIGN).

const LOGO_PLACEHOLDER_HTML =
    '<div style="width:120px; height:120px; border-radius:20px; background:#f3f4f6; border:2px dashed #d1d5db; display:flex; align-items:center; justify-content:center; font-family:Arial, Helvetica, sans-serif; font-size:13px; color:#9ca3af; text-align:center;">Inds\u00e6t<br>logo her</div>';

/** Placeholder the communication-templates API ships as the logo <img> source. */
const CLINIC_LOGO_PLACEHOLDER_TOKEN = 'CLINIC_LOGO_URL';

/**
 * Replace the logo placeholder in a template coming from the communication-templates API.
 * Without an outlet logo the whole <img> is swapped for the dashed placeholder box,
 * so the editor never shows a broken image.
 */
export const applyLogoToEmailTemplate = (html: string, profileImageUrl?: string): string => {
    if (!html.includes(CLINIC_LOGO_PLACEHOLDER_TOKEN)) return html;
    if (profileImageUrl) {
        return html.split(CLINIC_LOGO_PLACEHOLDER_TOKEN).join(profileImageUrl);
    }
    return html.replace(new RegExp(`<img[^>]*${CLINIC_LOGO_PLACEHOLDER_TOKEN}[^>]*>`, 'i'), LOGO_PLACEHOLDER_HTML);
};
